import {
  ColDef,
  GetContextMenuItemsParams,
  ITooltipParams,
  MenuItemDef,
  ValueFormatterParams,
  IDetailCellRendererParams,
} from 'ag-grid-enterprise';
import { Fund } from '~/types';

import { FundLinkCell } from '~/components/ui/tables/ag/documentsGroupTable/FundLinkCell';
import {
  ComputedMasterRow,
  ExtendedFund,
} from '~/components/ui/tables/ag/documentsGroupTable/types';
import { formatCurrency } from '~/lib/money';

export const colDefsDocumentMasterDetTable: ColDef<ComputedMasterRow>[] = [
  {
    field: 'jurisdiction.name',
    headerName: 'Jurisdiction',
    sortable: true,
    filter: true,
    // rowGroup: true,
    resizable: false,
    flex: 1,
    cellRenderer: 'agGroupCellRenderer',
    cellClass: 'flex align-items-center',
    tooltipValueGetter: (p: ITooltipParams) => p.value,
  },
  {
    field: 'fundCount',
    // cellRenderer: LivenessTagCellAg,
    suppressHeaderMenuButton: true,
    headerName: 'Total Funds',
    sortable: true,
    resizable: false,
    cellClass: 'flex align-items-center ',
    filter: true,
    // type: "w100",
  },
  {
    field: 'aumTotals',
    headerName: 'Total AUM',
    sortable: false,
    filter: true,
    // valueFormatter: (p) => formatCurrency(p.data?.currency??'EUR',p.value),
    resizable: false,
    flex: 1,
    suppressHeaderMenuButton: true,

    cellClass: 'flex align-items-center',
    // suppressHeaderMenuButton: true,
    // cellRenderer: RestatedTagCellAg,
  },
];

export const getDetailRowData = (
  params: IDetailCellRendererParams<ComputedMasterRow>,
) => {
  const { data } = params;
  return data?.funds ?? [];
};

/** Detail Render Params - sub grid
 * */
export const subTableDef = (
  params: GetContextMenuItemsParams<ExtendedFund>,
  contextMenu: (
    params: GetContextMenuItemsParams<ExtendedFund>,
  ) => (string | MenuItemDef)[],
) => {
  return {
    detailGridOptions: {
      getContextMenuItems: contextMenu,
      autoSizeStrategy: {
        type: 'fitGridWidth',
        defaultMinWidth: 100,
      },
      suppressCellFocus: true,
      columnDefs: [
        {
          field: 'name',
          headerName: 'Fund Name',
          sortable: false,
          filter: false,
          // type: "w50",
          suppressHeaderMenuButton: true,
          cellClass: 'flex align-items-center',
          cellRenderer: FundLinkCell,
          flex: 1,
          resizable: false,
          tooltipValueGetter: (p: ITooltipParams) => p.value,
        },
        {
          field: 'inceptionDate',
          headerName: 'Inception Date',
          sortable: true,
          cellClass: 'flex align-items-center',
          filter: 'agDateColumnFilter',
          resizable: false,
        },
        {
          field: 'terminationDate',
          suppressHeaderMenuButton: true,
          headerName: 'Termination Date',
          sortable: true,
          cellClass: 'flex align-items-center',
          filter: 'agDateColumnFilter',
          resizable: false,
          valueFormatter: (p: ValueFormatterParams<Fund>) => {
            return isNaN(p.value.getTime()) ? '' : p.value;
          },
        },
        {
          field: 'size',
          headerName: 'Fund Size',
          sortable: true,
          filter: true,
          resizable: false,
          valueFormatter: (p: ValueFormatterParams<Fund, number>) => {
            return typeof p.value === 'number'
              ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
              : '';
          },
          cellClass: 'flex align-items-center',
        },
        {
          field: 'currency',
          headerName: 'Fund Currency',
          cellClass: 'flex align-items-center',
          sortable: true,
          filter: true,
          flex: 1,
          resizable: false,
        },
      ],
    },
    getDetailRowData: (params: {
      data: ComputedMasterRow;
      successCallback: (data: ExtendedFund[]) => void;
    }) => {
      if (params.data?.funds) {
        params.successCallback(params.data.funds);
      }
    },
  };
};
